import { Done } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'

type ResolveAllButtonProps = {
  markAllMentionsResolved: () => void
  translate: (key: string) => string
}

export const ResolveAllButton = ({ markAllMentionsResolved, translate }: ResolveAllButtonProps) => {
  return (
    <Button
      variant="text"
      sx={{
        justifyContent: 'flex-start',
        gap: 2,
        color: 'secondary.dark',
        textTransform: 'none',
        cursor: 'pointer',
        ':hover': { background: 'none' },
      }}
      onClick={markAllMentionsResolved}
      disableRipple={false}
    >
      <Done sx={{ fontSize: '20px' }} />
      <Typography variant="Body12pxMedium">{translate('mentions.mark-all-resolved')}</Typography>
    </Button>
  )
}
